module.exports = __webpack_public_path__ + "static/media/magic-link-login-logo.f316dc7a.png";